define.alias("shared/components/shared/page-picker", "calendar/components/shared/page-picker");